/* global axios */
import ApiClient from './ApiClient';

class LaisQualificationQuestionsAPI extends ApiClient {
  constructor() {
    super('lais_qualification_questions', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, payload);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new LaisQualificationQuestionsAPI();
